module.exports = __webpack_public_path__ + "static/media/arrow-left-red.4cb68292.svg";